import '.d{display:flex;}.ssr-plugin'
import '.ak{aspect-ratio:1/1;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.al{padding:0.5rem;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import {
  faCheck,
  faWarning,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

export type Variant = 'success' | 'error'

const variantStyle: Record<Variant, Style> = {
  success: {
    color: 'var(--status-success-muted)',
    background: 'var(--status-success-vivid)',
  },
  error: {
    color: 'var(--palette-red-200)',
    background: 'var(--status-error)',
  },
}

const iconVariant: Record<Variant, IconDefinition> = {
  success: faCheck,
  error: faWarning,
}

export type IconProps = {
  variant: Variant
  icon?: IconDefinition
}

export const ToastIcon = ({ variant }: IconProps) => {
  const isMobile = useMediaQuery()
  return (
    <styled.div className="d ak ah al ad z"
      style={{
        width: isMobile ? '2.75rem' : '3.5rem',
        height: isMobile ? '2.75rem' : '3.5rem',
        borderRadius: isMobile ? '0.75rem' : '1rem',
        ...variantStyle[variant],
      }}
    >
      <FontAwesomeIcon
        icon={iconVariant[variant]}
        fontSize={isMobile ? '1.5rem' : '2.125rem'}
      />
    </styled.div>
  )
}
